import enviro from 'enviro';
import * as Hublets from '../hublets';
import { Subdomains } from '../subdomains';
export function getHubletPostfix(overrideConfig) {
  const hasHubletOverride = overrideConfig && overrideConfig.hubletOverride;
  const hubletToUse = hasHubletOverride ? overrideConfig.hubletOverride : enviro.getHublet();

  if (hubletToUse === Hublets.na1) {
    return '';
  }

  return `-${hubletToUse}`;
}
export function getSubDomain(prefix, overrideConfig) {
  const hasHubletPostfixOverride = overrideConfig && overrideConfig.hubletPostfixLocation && overrideConfig.hubletPostfixLocation === 'domain';

  if (hasHubletPostfixOverride) {
    return prefix;
  }

  if (prefix === Subdomains.APP_API) {
    prefix = Subdomains.APP;
  }

  return `${prefix}${getHubletPostfix(overrideConfig)}`;
}
export function getDomain(overrideConfig) {
  const domainPrefix = getDomainPrefix(overrideConfig);
  const envPostfix = getEnvPostfix(overrideConfig);
  const hubletDomainPostfix = getHubletDomainPostfix(overrideConfig);
  return `${domainPrefix}${envPostfix}${hubletDomainPostfix}`;
}
export function getEnvPostfix(overrideConfig) {
  const hasEnvOverride = overrideConfig && overrideConfig.envOverride;
  const envToUse = hasEnvOverride ? overrideConfig.envOverride : enviro.getShort();

  if (envToUse === 'qa') {
    return 'qa';
  }

  return '';
}
export function getDomainPrefix(overrideConfig) {
  const hasDomainOverride = overrideConfig && overrideConfig.domainOverride;

  if (hasDomainOverride) {
    return overrideConfig.domainOverride;
  }

  return 'hubspot';
}
export function getHubletDomainPostfix(overrideConfig) {
  const hasHubletPostfixxOverride = overrideConfig && overrideConfig.hubletPostfixLocation && overrideConfig.hubletPostfixLocation === 'domain';

  if (!hasHubletPostfixxOverride) {
    return '';
  }

  return getHubletPostfix(overrideConfig);
}
export function getTld(overrideConfig) {
  const hasTldOverride = overrideConfig && overrideConfig.tldOverride;

  if (hasTldOverride) {
    return overrideConfig.tldOverride;
  }

  return 'com';
}
export function getPathPrefix(subDomainPrefix) {
  if (subDomainPrefix === Subdomains.APP_API) {
    return '/api';
  }

  return '';
}